// ─── Astria Vietnam — English/Vietnamese.
// Follows the user's preferred language (utils/appLanguage.ts): Vietnamese
// when that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../../utils/appLanguage";

export type AstriaVietnamLanguage = "en" | "vi";

const SUPPORTED_LANGUAGES: readonly AstriaVietnamLanguage[] = ["en", "vi"];

const resolve = (appLanguage: string): AstriaVietnamLanguage =>
  pickLanguage(appLanguage, SUPPORTED_LANGUAGES);

export const getAstriaVietnamLanguage = (): AstriaVietnamLanguage =>
  resolve(getAppLanguage());

export function useAstriaVietnamLanguage(): AstriaVietnamLanguage {
  return resolve(useAppLanguage());
}
